import { render, staticRenderFns } from "./HomeChallengeButton.vue?vue&type=template&id=ac0be94c&scoped=true"
import script from "./HomeChallengeButton.vue?vue&type=script&lang=ts"
export * from "./HomeChallengeButton.vue?vue&type=script&lang=ts"
import style0 from "./HomeChallengeButton.vue?vue&type=style&index=0&id=ac0be94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0be94c",
  null
  
)

export default component.exports